import React from 'react';
import { useNavigate } from 'react-router-dom';
import Tree from 'components/Tree';
import TreeReactFlow from 'components/TreeReactFlow';

const TreePageReactFlow = () => <TreeReactFlow />;


export default TreePageReactFlow;
